module.exports = __webpack_public_path__ + "img/4.6c903e1e.png";